import { chartGlobalMarketsDuration } from "#constants";
import { useMarketsAnimation, useNumberFormat } from "#hooks";
import { Color } from "#shared/theme";
import { SvgTextSmall, SvgTextX } from "#ui";
import React, { useRef } from "react";
import { ChartMarketsProps } from "./chartProps";

export const America: React.FC<ChartMarketsProps> = ({ labels, ...props }) => {
  const currentPathRef = useRef<SVGCircleElement>(null);
  const contentRef = useRef<SVGGElement>(null);
  useMarketsAnimation({
    ...props,
    currentValue: Number(labels?.charts?.america),
    currentPathRef,
    contentRef,
    duration: chartGlobalMarketsDuration,
  });
  return (
    <g fill="none">
      <circle ref={currentPathRef} fill="none" stroke={Color.BlackLight} strokeWidth="10" cx="448" cy="272" r="160" />

      <SvgTextX ref={contentRef}>
        <SvgTextSmall>
          <text fill={Color.BlackLight} fontSize="14" transform="matrix(1 0 0 1 153.6696 315.2772)">
            {labels?.labels?.america}
          </text>
        </SvgTextSmall>
        <text fontSize="70" transform="matrix(1 0 0 1 153.6695 286.1649)">
          {useNumberFormat(Number(labels?.charts?.america), 1)}
        </text>
      </SvgTextX>
    </g>
  );
};
